/* eslint-disable prettier/prettier */
import * as gql from 'fake-tag';

export const AmbassadorRefFragment = {
  AmRef: gql`
    fragment AmRefQuery on ambassadorReferral_Entry {
      ctaStyle
      dropdownTitle
      image {
        url
        ... on images_Asset {
          altText
        }
      }
      lineBreak_content
      lineBreak_styles
      referralContent
      ambassadorRightContent
      referralDropdown {
        ... on referralDropdownBlock_Entry {
          dropdownLabel
          dropdownLink
          dropdownLinkNewTab
          dropdownLinkNofollow
        }
      }
      referralTitle
      styles
      typeHandle
    }
  `,
};
